export default "__VITE_ASSET__DbG7tiOl__"